import { $win } from '../utils/globals';

/**
 * Equalize elements height
 *
 * @return {void}
 */

$win.on('load resize', function() {
	$('.js-equalize-height').equalizeHeight();
});

$.fn.equalizeHeight = function() {
	var maxHeight = 0, itemHeight;

	this.css('height', '');

	for (var i = 0; i < this.length; i++) {
		itemHeight = $(this[i]).height();
		if (maxHeight < itemHeight) {
			maxHeight = itemHeight;
		}
	}

	return this.height(maxHeight);
}
